import React from "react";
import SidebarComponent from "../Reusables/SidebarComponent";
import styles from "./Success.module.css";

import { useNavigate } from "react-router-dom";
const EditSuccess = () => {
  const navigate = useNavigate();
  return (
    <>
      <div className={`${styles.top}`}>
        <SidebarComponent></SidebarComponent>
        <div className={styles.fill_div_spacing_01}></div>
        <div className={styles.second_column_div}>
          <div className={styles.card}>登録・変更を完了しました</div>
          <button
            className={styles.button}
            style={{ cursor: "pointer" }}
            onClick={() => {
              navigate("/top");
            }}
          >
            マイページ
          </button>
        </div>
      </div>
    </>
  );
};

export default EditSuccess;
